import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';

const SEP = '|';

/**
 * PDFQrCode module implementation.
 *
 * @author taatini1
 * @class PDFQrCode
 * @extends Tc.Module
 */
export default class PDFQrCode extends Module {
	private inputs : JQuery[] = [];
	private $inputElement! : JQuery;
	private placeholderName! : string;

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 */
	public on(callback : Hook) {
		this.placeholderName = this.$ctx.data('placeholder-name');
		this.$inputElement = this.$ctx.find('input');

		const nameList = this.$ctx.data('input-names') || [];

		for (const name of nameList) {
			const $elem = $(`input[name="${name}"]`);
			this.inputs.push($elem);
			$elem.on('change', this.updateValue.bind(this));
		}
		this.updateValue();

		callback();
	}

	private updateValue() {
		const value = this.inputs
			.map($el => $el.val())
			.join(SEP);

		const res = {
			name: this.placeholderName,
			text: `${value}${SEP}`,
		};

		this.$inputElement.val(JSON.stringify(res));
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/pdf/Tc.Module.PDFQrCode.ts